"use client";

import type { FC, PropsWithChildren } from "react";

import type { BuilderBlock } from "@builder.io/sdk-react";
import { Blocks, isEditing } from "@builder.io/sdk-react";

import { CountrySelector as UICountrySelector } from "@jti/ui/components/CountrySelector";

import type { countrySelectorInputs } from "./CountrySelector.builder";

export type CountrySelectorBuilderProps = Override<
  BuilderComponentProps<typeof countrySelectorInputs>,
  {
    richText?: BuilderBlock[];
    healthBanner?: BuilderBlock[];
  }
>;

export const CountrySelector: FC<PropsWithChildren<CountrySelectorBuilderProps>> = ({
  list,
  links,
  text,
  countriesApi,
  logoFileReference,
  backgroundImage,
  accessibilityDialogLabel,
  staticMode,
  healthBanner,
  richText,
  selectCountryLabel,
  builderBlock,
}) => {
  return (
    <UICountrySelector
      list={list}
      links={links}
      text={text}
      countriesApi={countriesApi}
      logoFileReference={logoFileReference}
      editor={isEditing()}
      accessibilityDialogLabel={accessibilityDialogLabel}
      staticMode={staticMode}
      backgroundImage={backgroundImage}
      selectCountryLabel={selectCountryLabel}
      healthBanner={
        healthBanner?.length ? (
          <Blocks blocks={healthBanner} path="healthBanner" parent={builderBlock?.id} />
        ) : undefined
      }
      richText={richText?.length ? <Blocks blocks={richText} path="richText" parent={builderBlock?.id} /> : undefined}
    />
  );
};
